import React from 'react';
import moment from 'moment';

const Post = ({post, uid}) => {
    return (
        <div className="post-list section">
            <div className="card post">
                <div className="card-content">
                    <span className="card-title">{post.title}</span>
                    <p>{post.content}</p>
                    <hr/>
                    <p>Posted by {post.authorFirstName} {post.authorLastName} </p>
                    <p>{post.dateCreated ? moment(post.dateCreated.toDate()).calendar() : null }</p>
                    {uid === post.authorId &&
                        <p>Activated: {post.activated ? "Yes": "No"}</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Post;